import { Component, OnInit, HostListener } from '@angular/core';
import { MyserviceService } from '../../provider/myservice.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { report_invoice_lang } from "../../language/report_invoice";
import * as XLSX from 'xlsx-js-style';
@Component({
  selector: 'app-print-report-invoice-excel',
  templateUrl: './print-report-invoice-excel.component.html',
  styleUrls: ['./print-report-invoice-excel.component.scss']
})

export class PrintReportInvoiceComponentExcel implements OnInit {
  @HostListener('window:afterprint', ['$event'])
  public afterPrintHandler(event) {
    window.close();
    window.stop();
    console.log('Printing finished or canceled.ๅๅๅ');
  }
  total_price = 0;
  total_price_value = '';
  print_datetime = '';
  report = '';
  day: any;
  month: any;
  year: any;
  type = null;
  reports: any;
  isLoading = true;
  lang = localStorage.getItem('lang') == "EN" ? "EN" : "TH";
  language: any;
  status_pay = null;
  date_filter = null;
  constructor(private route: ActivatedRoute, router: Router, private service: MyserviceService, private http: HttpClient) {
    this.language = report_invoice_lang[this.lang];
  }

  ngOnInit() {

    this.route.queryParams.subscribe(params => {
      //debugger
      this.status_pay = params['status_pay'];
      this.date_filter = params['date_filter'];
      if (params['report'] == '1') {
        var x = moment.unix(params['datetime']).locale('th-TH');
        var xy = 0;
        xy = parseInt(x.format('YYYY'));

        if (xy < 2500) {
          xy = xy + 543;
        }

        this.day = parseInt(x.format('DD'));
        this.month = parseInt(x.format('MM'));
        this.year = parseInt(x.format('YYYY'));
        this.print_datetime = x.format('DD MMMM ') + xy.toString();
        this.report = '1';
      }
      else if (params['report'] == '2') {
        var dateString = params['month'] + '-01-' + params['year'];
        var x = moment(dateString, 'MM-DD-YYYY').locale('th-TH');
        var xy = 0;
        xy = parseInt(x.format('YYYY'));

        if (xy < 2500) {
          xy = xy + 543;
        }

        this.day = parseInt(x.format('DD'));
        this.month = parseInt(x.format('MM'));
        this.year = parseInt(x.format('YYYY'));
        this.print_datetime = x.format('MMMM ') + xy.toString();
        console.log(this.print_datetime);
        this.report = '6';
      }
      else if (params['report'] == '3') {
        var dateString = '01-01-' + params['year'];
        var x = moment(dateString, 'MM-DD-YYYY').locale('th-TH');
        var xy = 0;
        xy = parseInt(x.format('YYYY'));

        if (xy < 2500) {
          xy = xy + 543;
        }

        this.day = parseInt(x.format('DD'));
        this.month = parseInt(x.format('MM'));
        this.year = parseInt(x.format('YYYY'));
        this.print_datetime = xy.toString();
        console.log(this.print_datetime);
        this.report = '7';
      }
      else if (params['report'] == '4') {
        this.day = '01';
        this.month = params['month'];
        this.year = params['year'];
        console.log(this.print_datetime);
        this.report = '4';
        this.type = '4';
      }
      else if (params['report'] == '5') {
        this.day = '01';
        this.month = params['month'];
        this.year = params['year'];
        console.log(this.print_datetime);
        this.report = '5';
        this.type = '5';
      }
      else {
        var x = moment.unix(params['datetime']).locale('th-TH');
        var xy = 0;
        xy = parseInt(x.format('YYYY'));

        if (xy < 2500) {
          xy = xy + 543;
        }

        this.day = '';
        this.month = '';
        this.year = '';
        this.print_datetime = x.format('DD MMMM ') + xy.toString();
        this.report = `#${params['report']}`
      }
    });

    this.refresh();
  }

  refresh() {
    this.service.postData({
      type: this.type,
      cancel: false,
      report_type: this.report,
      day: (this.day.toString().length == 1) ? '0' + this.day.toString() : this.day.toString(), month: (this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString()
      , year: this.year, status_pay: this.status_pay, date_filter: this.date_filter
    }, "reports-new/get_reports_all_invoice").then((result: any) => {
      this.reports = JSON.parse(JSON.stringify(result.data).replace(/\:null/gi, "\:\"\""))

      var formatter = new Intl.NumberFormat('th-TH', {
        style: 'currency',
        currency: 'THB',
      });
      this.http.get('/assets/file-excel/my_excel_file_invioce.xlsx', { responseType: 'arraybuffer' })
      .subscribe(async data => {
        const wb = XLSX.read(data, { type: 'array', cellStyles: true });

        // for (let tmb = 0; tmb <= this.reports.length - 1; tmb++) {

        //   var xy = 0;
        //   xy = parseInt(moment(this.reports[tmb].due_date).format('YYYY'));

        //   if (xy < 2500) {
        //     xy = xy + 543;
        //   }

        //   this.reports[tmb].due_date = moment(this.reports[tmb].due_date).format("DD/MM/") + xy;
        //   this.total_price += parseFloat(this.reports[tmb].total_price);
        //   this.reports[tmb].fee_type_price = formatter.format(this.reports[tmb].fee_type_price);

        // }
        this.total_price_value = formatter.format(this.total_price);
        this.isLoading = false;

        var startingMonth = 10;
        //ws_name result = ['test1', 'test2', 'test3']

        // Group the reports by customer_id and place_id
        var reportsByZone = this.reports.reduce((result, report) => {
          if (!result[report.zone_name]) {
            result[report.zone_name] = [];
          }
          result[report.zone_name].push(report);
          return result;
        }, {});

        //reportsByZone ={dda:[]}
        const wo_4: XLSX.WorkBook = XLSX.utils.book_new();


        const loop = Object.keys(reportsByZone)
        for (let ww = 0; ww < loop.length; ww++) {
          const zonename = loop[ww];
          const zone_n = zonename.replace('ชุมชน', '')
          console.log(wb.SheetNames);
          const ws = wb.Sheets[zone_n]
          var uniqueReports = {};

          const reports = reportsByZone[zonename];
          reports.forEach(function (report) {
            var key = report.customer_id + '-' + report.place_id;
            if (!uniqueReports[key]) {
              uniqueReports[key] = [];
            }
            uniqueReports[key].push(report);
          });

          var orderedMonths = Array.apply(null, Array(12)).map(function (_, index) {
            return (startingMonth + index - 1) % 12;
          });

          // Process the grouped reports
          var processedReports = Object.keys(uniqueReports).map(function (key, index) {
            var reports = uniqueReports[key];
            var monthlyData = Array.apply(null, Array(12)).map(function () {
              return {};
            });

            reports.forEach(function (report) {
              var monthIndex = moment(report.create_datetime).month();
              monthlyData[monthIndex] = {
                invoice_id: report.invoice_id,
                due_date: report.due_date,
                total_price: report.total_price,
              };
            });

            var flattenedMonthlyData = [].concat.apply(
              [],
              orderedMonths.map(function (monthIndex) {
                var data = monthlyData[monthIndex];
                return [
                  data.invoice_id || '',
                  data.due_date ? moment(data.due_date).format('DD-MM-YYYY') : '',
                  data.total_price ? data.total_price + 0.0 : '',
                ];
              }),
            );

            return [
              index + 1,
              reports[0].short_name,
              reports[0].customer_name + ' ' + reports[0].customer_surname,
              reports[0].place_number,
              reports[0].place_road,
              reports[0].tambon_th,
            ].concat(flattenedMonthlyData);
          });

          XLSX.utils.sheet_add_aoa(ws, processedReports, { origin: 'A4' });
          XLSX.utils.book_append_sheet(wo_4, ws, zonename);
          for (var i in ws) {
            console.log(ws[i]);
            if (typeof ws[i] != 'object') continue;
            let cell = XLSX.utils.decode_cell(i);

            ws[i].s = {

              // styling for all cells
              font: {
                name: 'Angsana New',
                sz: "16"
              },
              alignment: {
                vertical: 'center',
                horizontal: 'center',
                wrapText: '1', // any truthy value here
              },
              border: {
                right: {
                  style: 'thin',
                  color: '000000',
                },
                left: {
                  style: 'thin',
                  color: '000000',
                },
                top: {
                  style: 'thin',
                  color: '000000',
                },
                bottom: {
                  style: 'thin',
                  color: '000000',

                }

              },
            };

            if (cell.c == 6) {
              // first column
              ws[i].s.numFmt = 'DD-MM-YYYY'; // for dates
              ws[i].z = 'DD-MM-YYYY';
            } else {
              ws[i].s.numFmt = '00'; // other numbers
            }

            if (cell.r == 0) {
              // first row
              ws[i].s.border.bottom = {
                // bottom border
                style: 'thin',
                color: '000000',
              };
            }

            if (cell.r == 0) {
              // every other row
              ws[i].s.fill = {
                // background color
                patternType: 'solid',
                fgColor: { rgb: 'b2b2b2' },
                bgColor: { rgb: 'b2b2b2' },
              };
            }
          }
        }
        console.log(wo_4);




        XLSX.writeFile(wo_4, this.report == '1' ? 'invoice_days.xlsx' : this.report == '6' ? 'invoice_month.xlsx' : this.report == '7' ? 'invoice_year.xlsx' :this.report == '#99'?'invoice_All.xlsx': 'invoice_custom.xlsx', { cellStyles: true });
      });

      // switch (this.report) {
      //   case '1':
      //   case '6':
      //   case '7':
      //   case '#99': case '#98': case '#97':
      //     for (let tmb = 0; tmb <= this.reports.length - 1; tmb++) {
      //       this.reports[tmb].number_row = (tmb + 1).toString();

      //       var xy = 0;
      //       xy = parseInt(moment(this.reports[tmb].due_date).format('YYYY'));

      //       if (xy < 2500) {
      //         xy = xy + 543;
      //       }

      //       this.reports[tmb].due_date = moment(this.reports[tmb].due_date).format("DD/MM/") + xy;
      //       this.total_price += parseFloat(this.reports[tmb].total_price);
      //       this.reports[tmb].fee_type_price = formatter.format(this.reports[tmb].fee_type_price);
      //       if (tmb == this.reports.length - 1) {
      //         this.total_price_value = formatter.format(this.total_price);
      //         this.isLoading = false;

      //         const newArray_days = this.reports.map(report => {
      //           return {
      //             'ลำดับ': report.number_row,
      //             'รหัสใบแจ้งหนี้': report.invoice_id,
      //             'วันที่ออกใบแจ้งหนี้': report.due_date,
      //             'รหัสที่อยู่': report.place_id,
      //             'ชื่อผู้เสียภาษี': report.customer_name,
      //             'ที่อยู่/บ้านเลขที่': report.place_address,
      //             'ชนิดที่อยู่': report.place_type_description,
      //             'ประเภทค่าธรรมเนียม': report.fee_type_description,
      //             'ยอดที่ต้องชำระ': formatter.format(report.total_price),
      //             'สถานะการชำระ': report.payment_description
      //             // add more key-value pairs as needed
      //           }
      //         });


      //         // const range = XLSX.utils.decode_range(wsxzz['!ref']);
      //         // for (let R = range.s.r; R <= range.e.r; ++R) {
      //         //   for (let C = range.s.c; C <= range.e.c; ++C) {
      //         //     const cell_address = XLSX.utils.encode_cell({ r: R, c: C });
      //         //     const cell_style = { border: { top: { style: 'thin' }, bottom: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' } } };
      //         //     XLSX.utils.sheet_set_range_style(wsxzz, cell_address, cell_style);
      //         //   }
      //         // }

      //         const wsxzz: XLSX.WorkSheet = XLSX.utils.json_to_sheet(newArray_days);
      //         for (var i in wsxzz) {
      //           console.log(wsxzz[i]);
      //           if (typeof wsxzz[i] != 'object') continue;
      //           let cell = XLSX.utils.decode_cell(i);

      //           wsxzz[i].s = {

      //             // styling for all cells
      //             font: {
      //               name: 'Angsana New',
      //               sz: "16"
      //             },
      //             alignment: {
      //               vertical: 'center',
      //               horizontal: 'center',
      //               wrapText: '1', // any truthy value here
      //             },
      //             border: {
      //               right: {
      //                 style: 'thin',
      //                 color: '000000',
      //               },
      //               left: {
      //                 style: 'thin',
      //                 color: '000000',
      //               },
      //               top: {
      //                 style: 'thin',
      //                 color: '000000',
      //               },
      //               bottom: {
      //                 style: 'thin',
      //                 color: '000000',

      //               }

      //             },
      //           };

      //           if (cell.c == 6) {
      //             // first column
      //             wsxzz[i].s.numFmt = 'DD-MM-YYYY'; // for dates
      //             wsxzz[i].z = 'DD-MM-YYYY';
      //           } else {
      //             wsxzz[i].s.numFmt = '00'; // other numbers
      //           }

      //           if (cell.r == 0) {
      //             // first row
      //             wsxzz[i].s.border.bottom = {
      //               // bottom border
      //               style: 'thin',
      //               color: '000000',
      //             };
      //           }

      //           if (cell.r == 0) {
      //             // every other row
      //             wsxzz[i].s.fill = {
      //               // background color
      //               patternType: 'solid',
      //               fgColor: { rgb: 'b2b2b2' },
      //               bgColor: { rgb: 'b2b2b2' },
      //             };
      //           }
      //         }
      //         const wbzxx: XLSX.WorkBook = XLSX.utils.book_new();
      //         wsxzz['!cols'] = [{ width: 10 }, { width: 20 }, { width: 30 }, { width: 30 }, { width: 30 }, { width: 30 }, { width: 30 }, { width: 30 }, { width: 30 }, { width: 30 }];
      //         XLSX.utils.book_append_sheet(wbzxx, wsxzz, 'Reports');
      //         XLSX.writeFile(wbzxx, `invoice_${this.report == '1' ? 'days' : this.report == '6' ? 'month' : this.report == '7' ? 'year' : 'All'}.xlsx`);
      //       }
      //     }


      //     break;

      //   case '6':
      //     for (let tmb = 0; tmb <= this.reports.length - 1; tmb++) {
      //       this.reports[tmb].number_row = (tmb + 1).toString();
      //       this.total_price += parseFloat(this.reports[tmb].total_price);
      //       this.reports[tmb].total_price = formatter.format(this.reports[tmb].total_price);


      //       let x = this.service.postData({ report_type: '41', day: (this.reports[tmb].days.toString().length == 1) ? '0' + this.reports[tmb].days.toString() : this.reports[tmb].days.toString(), month: (this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString(), year: this.year, status_pay: this.status_pay }, "reports-new/get_reports_all_invoice").then((result2: any) => {
      //         //debugger;
      //         var res2 = JSON.parse(JSON.stringify(result2.data).replace(/\:null/gi, "\:\"\""));
      //         //debugger;

      //         if (res2.length > 0) {
      //           this.reports[tmb].ty01 = res2[0].ty01;
      //           this.reports[tmb].ty02 = res2[0].ty02;
      //         }

      //         if (tmb == this.reports.length - 1) {
      //           const newArray_month = this.reports.map(report => {
      //             return {
      //               'ลำดับ': report.number_row,
      //               'วันที่': report.days,
      //               'ขยะมูลฝอย': report.ty01,
      //               'ขยะติดเชื้อและอื่นๆ': report.ty02,
      //               'จำนวนที่ออกเอกสาร': report.doc_counts,
      //               'ค่าธรรมเนียม': report.total_price,
      //               // add more key-value pairs as needed
      //             }
      //           });
      //           this.total_price_value = formatter.format(this.total_price);
      //           this.isLoading = false;


      //           const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(newArray_month);
      //           for (var i in ws) {
      //             console.log(ws[i]);
      //             if (typeof ws[i] != 'object') continue;
      //             let cell = XLSX.utils.decode_cell(i);

      //             ws[i].s = {

      //               // styling for all cells
      //               font: {
      //                 name: 'Angsana New',
      //                 sz: "16"
      //               },
      //               alignment: {
      //                 vertical: 'center',
      //                 horizontal: 'center',
      //                 wrapText: '1', // any truthy value here
      //               },
      //               border: {
      //                 right: {
      //                   style: 'thin',
      //                   color: '000000',
      //                 },
      //                 left: {
      //                   style: 'thin',
      //                   color: '000000',
      //                 },
      //                 top: {
      //                   style: 'thin',
      //                   color: '000000',
      //                 },
      //                 bottom: {
      //                   style: 'thin',
      //                   color: '000000',

      //                 }

      //               },
      //             };

      //             if (cell.c == 6) {
      //               // first column
      //               ws[i].s.numFmt = 'DD-MM-YYYY'; // for dates
      //               ws[i].z = 'DD-MM-YYYY';
      //             } else {
      //               ws[i].s.numFmt = '00'; // other numbers
      //             }

      //             if (cell.r == 0) {
      //               // first row
      //               ws[i].s.border.bottom = {
      //                 // bottom border
      //                 style: 'thin',
      //                 color: '000000',
      //               };
      //             }

      //             if (cell.r == 0) {
      //               // every other row
      //               ws[i].s.fill = {
      //                 // background color
      //                 patternType: 'solid',
      //                 fgColor: { rgb: 'b2b2b2' },
      //                 bgColor: { rgb: 'b2b2b2' },
      //               };
      //             }
      //           }
      //           const wb: XLSX.WorkBook = XLSX.utils.book_new();
      //           ws['!cols'] = [{ width: 10 }, { width: 20 }, { width: 30 }, { width: 30 }, { width: 30 }, { width: 30 }];
      //           XLSX.utils.book_append_sheet(wb, ws, 'Reports');
      //           XLSX.writeFile(wb, 'invoice_month.xlsx');


      //         }
      //       })
      //     }



      //     break;

      //   case '7':
      //     for (let tmb = 0; tmb <= this.reports.length - 1; tmb++) {
      //       this.reports[tmb].number_row = (tmb + 1).toString();
      //       this.total_price += parseFloat(this.reports[tmb].total_price);


      //       let x = this.service.postData({ report_type: '51', day: (this.day.toString().length == 1) ? '0' + this.day.toString() : this.day.toString(), month: (this.reports[tmb].month.toString().length == 1) ? '0' + this.reports[tmb].month.toString() : this.reports[tmb].month.toString(), year: this.year, status_pay: this.status_pay },
      //         "reports-new/get_reports_all_invoice").then((result2: any) => {
      //           //debugger;
      //           var res2 = JSON.parse(JSON.stringify(result2.data).replace(/\:null/gi, "\:\"\""));
      //           //debugger;
      //           if (result2.data.length > 0) {
      //             this.reports[tmb].ty01 = res2[0].ty01;
      //             this.reports[tmb].ty02 = res2[0].ty02;
      //             switch (this.reports[tmb].month) {
      //               case '01':
      //                 this.reports[tmb].month = 'มกราคม';
      //                 break
      //               case '02':
      //                 this.reports[tmb].month = 'กุมภาพันธ์';
      //                 break
      //               case '03':
      //                 this.reports[tmb].month = 'มีนาคม';
      //                 break
      //               case '04':
      //                 this.reports[tmb].month = 'เมษายน';
      //                 break
      //               case '05':
      //                 this.reports[tmb].month = 'พฤษภาคม';
      //                 break
      //               case '06':
      //                 this.reports[tmb].month = 'มิถุนายน';
      //                 break
      //               case '07':
      //                 this.reports[tmb].month = 'กรกฏาคม';
      //                 break
      //               case '08':
      //                 this.reports[tmb].month = 'สิงหาคม';
      //                 break
      //               case '09':
      //                 this.reports[tmb].month = 'กันยายน';
      //                 break
      //               case '10':
      //                 this.reports[tmb].month = 'ตุลาคม';
      //                 break
      //               case '11':
      //                 this.reports[tmb].month = 'พฤศจิกายน';
      //                 break
      //               case '12':
      //                 this.reports[tmb].month = 'ธันวาคม';
      //                 break
      //             }
      //             console.log(this.reports);
      //             this.reports[tmb].total_price = formatter.format(this.reports[tmb].total_price);
      //             if (tmb == this.reports.length - 1) {
      //               this.total_price_value = formatter.format(this.total_price);
      //               this.isLoading = false;

      //               const newArray_year_ = this.reports.map(report => {
      //                 console.log(report);
      //                 return {
      //                   'ลำดับ': report.number_row,
      //                   'เดือน': report.month,
      //                   'ขยะมูลฝอย': report.ty01,
      //                   'ขยะติดเชื้อและอื่นๆ': report.ty02,
      //                   'จำนวนที่ออกเอกสาร': report.doc_counts,
      //                   'ค่าธรรมเนียม': report.total_price
      //                   // add more key-value pairs as needed
      //                 }
      //               });

      //               const wp: XLSX.WorkSheet = XLSX.utils.json_to_sheet(newArray_year_);
      //               for (var i in wp) {
      //                 console.log(wp[i]);
      //                 if (typeof wp[i] != 'object') continue;
      //                 let cell = XLSX.utils.decode_cell(i);

      //                 wp[i].s = {

      //                   // styling for all cells
      //                   font: {
      //                     name: 'Angsana New',
      //                     sz: "16"
      //                   },
      //                   alignment: {
      //                     vertical: 'center',
      //                     horizontal: 'center',
      //                     wrapText: '1', // any truthy value here
      //                   },
      //                   border: {
      //                     right: {
      //                       style: 'thin',
      //                       color: '000000',
      //                     },
      //                     left: {
      //                       style: 'thin',
      //                       color: '000000',
      //                     },
      //                     top: {
      //                       style: 'thin',
      //                       color: '000000',
      //                     },
      //                     bottom: {
      //                       style: 'thin',
      //                       color: '000000',

      //                     }

      //                   },
      //                 };

      //                 if (cell.c == 6) {
      //                   // first column
      //                   wp[i].s.numFmt = 'DD-MM-YYYY'; // for dates
      //                   wp[i].z = 'DD-MM-YYYY';
      //                 } else {
      //                   wp[i].s.numFmt = '00'; // other numbers
      //                 }

      //                 if (cell.r == 0) {
      //                   // first row
      //                   wp[i].s.border.bottom = {
      //                     // bottom border
      //                     style: 'thin',
      //                     color: '000000',
      //                   };
      //                 }

      //                 if (cell.r == 0) {
      //                   // every other row
      //                   wp[i].s.fill = {
      //                     // background color
      //                     patternType: 'solid',
      //                     fgColor: { rgb: 'b2b2b2' },
      //                     bgColor: { rgb: 'b2b2b2' },
      //                   };
      //                 }
      //               }
      //               const wa: XLSX.WorkBook = XLSX.utils.book_new();
      //               wp['!cols'] = [{ width: 10 }, { width: 20 }, { width: 30 }, { width: 30 }, { width: 30 }, { width: 30 }, { width: 30 }, { width: 30 }];
      //               XLSX.utils.book_append_sheet(wa, wp, 'Reports');
      //               XLSX.writeFile(wa, 'invoice_year.xlsx');

      //             }

      //           }

      //         })


      //     }

      //     break;

      //   case '5':

      //     for (let tmb = 0; tmb <= this.reports.length - 1; tmb++) {
      //       this.reports[tmb].number_row = (tmb + 1).toString();

      //       var xy = 0;
      //       xy = parseInt(moment(this.reports[tmb].due_date).format('YYYY'));

      //       if (xy < 2500) {
      //         xy = xy + 543;
      //       }

      //       this.reports[tmb].due_date = moment(this.reports[tmb].due_date).format("DD/MM/") + xy;
      //       this.total_price += parseFloat(this.reports[tmb].total_price);
      //       this.reports[tmb].fee_type_price = formatter.format(this.reports[tmb].fee_type_price);
      //       if (tmb == this.reports.length - 1) {
      //         this.total_price_value = formatter.format(this.total_price);
      //         this.isLoading = false;
      //         const newArray_days_5 = this.reports.map(report => {
      //           return {
      //             'ลำดับ': report.number_row,
      //             'เลขที่ใบทวงหนี้': report.invoice_id,
      //             'วันที่ออกเอกสาร': report.due_date,
      //             'รหัสอาคาร': report.place_id,
      //             'ชื่อ-นามสกุล': report.customer_name,
      //             'ที่อยู่': report.place_address,
      //             'ชนิดค่าธรรมเนียม': report.fee_type_description,
      //             'ค่าธรรมเนียม': report.fee_type_price,

      //             // add more key-value pairs as needed
      //           }
      //         });
      //         const wi_5 = XLSX.utils.book_new();
      //         const wo_5 = XLSX.utils.json_to_sheet(newArray_days_5);
      //         wo_5['!cols'] = [{ width: 10 }, { width: 20 }, { width: 30 }, { width: 30 }, { width: 30 }, { width: 30 }];

      //         XLSX.utils.book_append_sheet(wi_5, wo_5, 'Reports');
      //         XLSX.writeFile(wi_5, 'invoice_6month.xlsx');
      //       }
      //     }

      //     break;

      //   case '4':

      //     for (let tmb = 0; tmb <= this.reports.length - 1; tmb++) {
      //       this.reports[tmb].number_row = (tmb + 1).toString();

      //       var xy = 0;
      //       xy = parseInt(moment(this.reports[tmb].due_date).format('YYYY'));

      //       if (xy < 2500) {
      //         xy = xy + 543;
      //       }

      //       this.reports[tmb].due_date = moment(this.reports[tmb].due_date).format("DD/MM/") + xy;
      //       this.total_price += parseFloat(this.reports[tmb].total_price);
      //       this.reports[tmb].fee_type_price = formatter.format(this.reports[tmb].fee_type_price);
      //       if (tmb == this.reports.length - 1) {
      //         this.total_price_value = formatter.format(this.total_price);
      //         this.isLoading = false;
      //         const newArray_days_4 = this.reports.map(report => {
      //           return {
      //             'ลำดับ': report.number_row,
      //             'รหัสใบแจ้งหนี้': report.invoice_id,
      //             'วันที่ออกใบแจ้งหนี้': report.due_date,
      //             'รหัสที่อยู่': report.place_id,
      //             'ชื่อผู้เสียภาษี': report.customer_name,
      //             'ที่อยู่/บ้านเลขที่': report.place_address,
      //             'ชนิดที่อยู่': report.place_type_description,
      //             'ประเภทค่าธรรมเนียม': report.fee_type_description,
      //             'ยอดที่ต้องชำระ': formatter.format(report.total_price),
      //             'สถานะการชำระ': report.payment_description
      //             // add more key-value pairs as needed
      //           }
      //         });

      //         const wi_4: XLSX.WorkSheet = XLSX.utils.json_to_sheet(newArray_days_4);
      //         for (var i in wi_4) {
      //           console.log(wi_4[i]);
      //           if (typeof wi_4[i] != 'object') continue;
      //           let cell = XLSX.utils.decode_cell(i);

      //           wi_4[i].s = {

      //             // styling for all cells
      //             font: {
      //               name: 'Angsana New',
      //               sz: "16"
      //             },
      //             alignment: {
      //               vertical: 'center',
      //               horizontal: 'center',
      //               wrapText: '1', // any truthy value here
      //             },
      //             border: {
      //               right: {
      //                 style: 'thin',
      //                 color: '000000',
      //               },
      //               left: {
      //                 style: 'thin',
      //                 color: '000000',
      //               },
      //               top: {
      //                 style: 'thin',
      //                 color: '000000',
      //               },
      //               bottom: {
      //                 style: 'thin',
      //                 color: '000000',

      //               }

      //             },
      //           };

      //           if (cell.c == 6) {
      //             // first column
      //             wi_4[i].s.numFmt = 'DD-MM-YYYY'; // for dates
      //             wi_4[i].z = 'DD-MM-YYYY';
      //           } else {
      //             wi_4[i].s.numFmt = '00'; // other numbers
      //           }

      //           if (cell.r == 0) {
      //             // first row
      //             wi_4[i].s.border.bottom = {
      //               // bottom border
      //               style: 'thin',
      //               color: '000000',
      //             };
      //           }

      //           if (cell.r == 0) {
      //             // every other row
      //             wi_4[i].s.fill = {
      //               // background color
      //               patternType: 'solid',
      //               fgColor: { rgb: 'b2b2b2' },
      //               bgColor: { rgb: 'b2b2b2' },
      //             };
      //           }
      //         }
      //         const wo_4: XLSX.WorkBook = XLSX.utils.book_new();
      //         wi_4['!cols'] = [{ width: 10 }, { width: 20 }, { width: 30 }, { width: 30 }, { width: 30 }, { width: 30 }, { width: 30 }, { width: 30 }, { width: 30 }, { width: 30 }];
      //         XLSX.utils.book_append_sheet(wo_4, wi_4, 'Reports');
      //         XLSX.writeFile(wo_4, 'inform_custom.xlsx');

      //       }
      //     }

      //     break;
      //   case '#99': case '#98': case '#97':
      //     for (let tmb = 0; tmb <= this.reports.length - 1; tmb++) {
      //       this.reports[tmb].number_row = (tmb + 1).toString();
      //       this.total_price += parseFloat(this.reports[tmb].total_price);
      //       xy = parseInt(moment(this.reports[tmb].due_date).format('YYYY'));

      //       if (xy < 2500) {
      //         xy = xy + 543;
      //       }
      //       let x = this.service.postData({ report_type: '##', day: '', month: '', year: '', other: this.report, status_pay: this.status_pay }, "reports-new/get_reports_all_invoice").then((result2: any) => {
      //         //debugger;
      //         var res2 = JSON.parse(JSON.stringify(result2.data).replace(/\:null/gi, "\:\"\""));
      //         //debugger;
      //         console.log(result2.data.length)
      //         if (result2.data.length > 0) {
      //           this.reports[tmb].ty01 = result2.data[0].ty01;
      //           this.reports[tmb].ty02 = result2.data[0].ty02;
      //           this.reports[tmb].total_price = formatter.format(this.reports[tmb].total_price);
      //           this.reports[tmb].year = `${Number(this.reports[tmb].year) + 543}`
      //           if (tmb == this.reports.length - 1) {
      //             this.total_price_value = formatter.format(this.total_price);
      //             this.isLoading = false;

      //             const newArray_year = this.reports.map(report => {
      //               return {
      //                 'ลำดับ': report.number_row,
      //                 'ปี': xy,
      //                 'ขยะมูลฝอย': report.ty01,
      //                 'ขยะติดเชื้อและอื่นๆ': report.ty02,
      //                 'จำนวนที่ออกเอกสาร': report.doc_counts,
      //                 'ค่าธรรมเนียม': report.total_price
      //                 // add more key-value pairs as needed
      //               }
      //             });
      //             const wsxzzz: XLSX.WorkSheet = XLSX.utils.json_to_sheet(newArray_year);
      //             for (var i in wsxzzz) {
      //               console.log(wsxzzz[i]);
      //               if (typeof wsxzzz[i] != 'object') continue;
      //               let cell = XLSX.utils.decode_cell(i);

      //               wsxzzz[i].s = {

      //                 // styling for all cells
      //                 font: {
      //                   name: 'Angsana New',
      //                   sz: "16"
      //                 },
      //                 alignment: {
      //                   vertical: 'center',
      //                   horizontal: 'center',
      //                   wrapText: '1', // any truthy value here
      //                 },
      //                 border: {
      //                   right: {
      //                     style: 'thin',
      //                     color: '000000',
      //                   },
      //                   left: {
      //                     style: 'thin',
      //                     color: '000000',
      //                   },
      //                   top: {
      //                     style: 'thin',
      //                     color: '000000',
      //                   },
      //                   bottom: {
      //                     style: 'thin',
      //                     color: '000000',

      //                   }

      //                 },
      //               };

      //               if (cell.c == 6) {
      //                 // first column
      //                 wsxzzz[i].s.numFmt = 'DD-MM-YYYY'; // for dates
      //                 wsxzzz[i].z = 'DD-MM-YYYY';
      //               } else {
      //                 wsxzzz[i].s.numFmt = '00'; // other numbers
      //               }

      //               if (cell.r == 0) {
      //                 // first row
      //                 wsxzzz[i].s.border.bottom = {
      //                   // bottom border
      //                   style: 'thin',
      //                   color: '000000',
      //                 };
      //               }

      //               if (cell.r == 0) {
      //                 // every other row
      //                 wsxzzz[i].s.fill = {
      //                   // background color
      //                   patternType: 'solid',
      //                   fgColor: { rgb: 'b2b2b2' },
      //                   bgColor: { rgb: 'b2b2b2' },
      //                 };
      //               }
      //             }
      //             const wbzxxx: XLSX.WorkBook = XLSX.utils.book_new();
      //             wsxzzz['!cols'] = [{ width: 10 }, { width: 20 }, { width: 30 }, { width: 30 }, { width: 30 }, { width: 30 }];
      //             XLSX.utils.book_append_sheet(wbzxxx, wsxzzz, 'Reports');
      //             XLSX.writeFile(wbzxxx, 'invoice_All.xlsx');



      //           }
      //         }

      //       })


      //     }


      //     break;
      // }


    }, (err) => {
      this.isLoading = false;
      Swal.fire({
        title: this.language.no_internet_alert,
        text: '',
        type: 'error',
        showCancelButton: false,
        showConfirmButton: false,
        timer: 2000
      });
    });
  }

}
